import { render, staticRenderFns } from "./CasysDetectionDetailPage.vue?vue&type=template&id=2289e884&"
import script from "./CasysDetectionDetailPage.vue?vue&type=script&lang=ts&"
export * from "./CasysDetectionDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports